import { render, staticRenderFns } from "./DataShared.vue?vue&type=template&id=0ed7bbe4"
import script from "./DataShared.vue?vue&type=script&lang=ts"
export * from "./DataShared.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports